<template>

    <div class="w-100 border">
        <div v-on:click="panelContent = !panelContent" class="w-100 color-magenta p-3 collapsible-panel" >
            {{title}} <b-icon-chevron-right :class="{toggled: panelContent == true}" />
        </div>
        
            <div v-if="panelContent" class="content-panel">
                <slot></slot>
            </div>
    </div>
</template>

<script>


    export default {
        name: 'CollapsiblePanel',
        components: {
        },
        props: {
            title: String,
            value: Boolean
        },
        data: function () {

            return {
				panelContent: this.value
            }

        },
        methods: {

        },
        watch: {
			panelContent: function (newValue) {
				//v-model outwards
				this.$emit('input', newValue)
				
            },
			value: function (newValue) {
				//v-model-inward
				this.panelContent = newValue
			},
        },
        mounted: function () {

        },
        updated: function(){

        }
    }
</script>
